import { useEffect, useState } from 'react'
import { getExperimentClient } from '@/helpers/experimentClient'

const FLAG_KEY = 'paywall_cleaner'
type PaywallVariant = '3_price_paywall' | '1_price_paywall'

export function usePaywallVariant() {
  const [variant, setVariant] = useState<PaywallVariant | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const run = async () => {
      try {
        const client = getExperimentClient()
        await client.fetch()
        if (cancelled) return
        const v = client.variant(FLAG_KEY)
        const value = (v.value as PaywallVariant) || '3_price_paywall'
        setVariant(value)
      } catch (e) {
        console.error('Experiment error', e)
        if (!cancelled) setVariant('3_price_paywall')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    run()

    return () => {
      cancelled = true
    }
  }, [])

  return { variant, loading }
}
